import {connect} from 'react-redux';
import NotFoundView from '../components/views/NotFoundView';
import * as WizardMXActions from '../actions/WizardMXActions';
import {isEmpty} from '../../common/utils/ValidationUtils';

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({
    onPressInit: () => {
        dispatch(WizardMXActions.GO_TO_CALCULATOR_MX_ACTION.action());
    }
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
});

const PageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(NotFoundView);

export default PageContainer;
